//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

import Backoff from  './lib/backoff'
import FibonacciBackoffStrategy from './lib/strategies/fibonacci'

// const ExponentialBackoffStrategy = import './lib/strategy/exponential'
// const FunctionCall = import './lib/function_call.js'

// export { default as Backoff } from './lib/backoff'
// export { default as FibonacciStrategy } from './lib/strategies/fibonacci' 
// export const FunctionCall = FunctionCall
// export .ExponentialStrategy = ExponentialBackoffStrategy

// Constructs a Fibonacci backoff.
export function fibonacci(options) {
  return new Backoff(new FibonacciBackoffStrategy(options))
}

// Constructs an exponential backoff.
// export .exponential = function(options) {
//     return new Backoff(new ExponentialBackoffStrategy(options))
// }

// Constructs a FunctionCall for the given function and arguments.
// export .call = function(fn, vargs, callback) {
//     var args = Array.prototype.slice.call(arguments)
//     fn = args[0]
//     vargs = args.slice(1, args.length - 1)
//     callback = args[args.length - 1]
//     return new FunctionCall(fn, vargs, callback)
// }
